<template>
  <vs-prompt
    :key="formkey"
    color="warning"
    :type="type == 'consulente' ? 'confirm' : 'alert'"
    :title="['Firma',type].join(' ')"
    @close="closeThis"
    :buttons-hidden="true"
    :active.sync="active_pop">

      <vs-row v-if="localSignature" class="w-full">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vueSignature ref="signature"
                style="border: 1px solid #666"
                :sigOption="option"
                :w="'800px'" :h="'400px'" />
        </vs-col>
      </vs-row>

      <vs-row v-if="localSignature">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-alert :active="true" color="warning" icon="new_releases" >
            Disegnare la firma
          </vs-alert>
        </vs-col>
      </vs-row>

      <vs-row v-if="localSignature" class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button @click="clearSignature" icon-pack="feather" icon="icon-trash" color="danger" type="line">Pulisci</vs-button>
          <vs-button @click="saveSignature" icon-pack="feather" icon="icon-save" color="success" type="line">Salva</vs-button>
        </vs-col>
      </vs-row>

      <form v-on:submit.prevent="" data-vv-scope="signature" autocomplete="off" class="w-full">
        <vs-row>
          <!-- <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
            <label class="text-sm">Email</label>
          </vs-col> -->
          <vs-col vs-justify="center" vs-align="center">
            <label class="text-sm">Email</label>
            <vs-input class="w-full" name="email_to" v-model="email_to" autocomplete="false" placeholder="Email firmatario" v-validate="'required|email'" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('utente.email')">{{ errors.first('utente.email') }}</span>

            <vs-input v-model="email_to" placeholder="email firmatario" class="w-full m-2" name="email_to" v-validate="'email'"/> -->
            <span class="text-danger text-sm" v-show="errors.has('signature.email_to')">{{ errors.first('signature.email_to') }}</span>

          </vs-col>

          <!-- <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
            <label class="text-sm">Nome completo</label>
          </vs-col> -->
          <vs-col class="mt-2" vs-justify="center" vs-align="center">
            <label class="text-sm">Nome completo</label>
            <vs-input v-model="name_to" placeholder="nome firmatario" class="w-full" name="name_to" v-validate="'required|min:5'" />
            <span class="text-danger text-sm" v-show="errors.has('signature.name_to')">{{ errors.first('signature.name_to') }}</span>
          </vs-col>
  <!--
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
            <label class="text-sm">Telefono</label>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
            <vs-input v-model="otp_tel" placeholder="numero telefono firmatario" class="w-full mx-2" name="otp_tel" />
          </vs-col> -->
        </vs-row>
      </form>

      <vs-row class="my-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <p style="color:orange;">Verificare la mail, poichè necessaria per portare a termine l'operazione di firma.</p>
          <!-- <p style="color:orange;">Verificare il numero inserito, poichè necessario per portare a termine l'operazione di firma.</p> -->
        </vs-col>
        <!-- <vs-col v-if="!(valid_mail)" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"> -->
        <!-- <vs-col v-if="!(valid_tel && valid_mail)" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"> -->
          <!-- <p style="color:red;">Verificare la mail inserita prima di procedere.</p> -->
          <!-- <p style="color:red;">Verificare i campi inseriti prima di procedere.</p> -->
        <!-- </vs-col> -->
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button @click="sendDocumentToSign" type="flat" icon-pack="feather" icon="icon-send">Invia</vs-button>
          <!-- <vs-button :disabled="!(valid_mail)" @click="sendDocumentToSign" type="flat" icon-pack="feather" icon="icon-send">Invia</vs-button> -->
          <!-- <vs-button :disabled="!(valid_tel && valid_mail)" @click="sendDocumentToSign" type="flat" icon-pack="feather" icon="icon-send">Invia</vs-button> -->
        </vs-col>
      </vs-row>

 </vs-prompt>
</template>

<script>
// For custom error message
import { Validator } from 'vee-validate';

const dict = {
  signature: {
    name_to: {
      required: 'Nome è un campo obbligatorio',
      min: 'Inserire almeno 5 caratteri'
    },
    email_to: {
      required: 'Email è un campo obbligatorio',
      email: 'Inserire un indirizzo email valido',
    },
    otp_tel: {
      required: 'Specificare il numero di telefono'
    },
  }
};
// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      formkey: Math.random(),
      localSignature: false,
      otp_tel: '',
      email_to: '',
      name_to: '',
      valid_mail: false,
      valid_tel: false,
      x_file_name: '',
      x_file_path: '',
      option: {
        penColor: 'rgb(0,0,0)',
        backgroundColor: 'rgb(255,255,255)',
      },
    }
  },
  props: {
    active_pop: Boolean,
    contratto: Object,
    id_stato: Number,
    type: String,
    data: Object,
    uff: Array,
  },
  watch: {
    email_to(val) {
      if (val.length > 4) {
        // email validation
        this.valid_mail = true
      } else {
        this.valid_mail = false
      }
    },
    otp_tel(val) {
      if (val.length > 4) {
        // tel number validation
        this.valid_tel = true
      } else {
        this.valid_tel = false
      }
    },
  },
  mounted () {
    this.email_to = this.$az.getRappresentanteEmail(this.contratto.preventivo.azienda)
    this.name_to = this.$az.getRappresentanteFullname(this.contratto.preventivo.azienda)
    // console.log('tipologia firma:',this.type,'\ncontratto id:',this.contratto.id,'\ndata:',this.data);
    // if (this.data) {
    //   console.log('ho una firma da mostrare');
    // } else {
    //   console.log('blank canvas');
    // }
  },
  methods: {
    validateSignatureRequest() {
      // console.log('VALIDATE');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('signature').then(result => {
          if (result) {
            console.log('success');
            resolve(true)
          } else {
            console.log('failed');
            reject("correct all values");
          }
        })
      })
    },
    async sendDocumentToSign() {
      this.validateSignatureRequest().then(async () => {
        this.activeLoading = true
        this.$vs.loading({
          type:'radius',
        })

        let p_to_print = {...this.contratto}

        p_to_print = await this.$tariffe.generatePDFcontratto(p_to_print)

        axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/generate_file', {
          templates: p_to_print.templates,
          object: p_to_print,
          contratto: true,
          save: true,
          sign: true
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        })
        .then(async response => {
            // console.log('PDF creato: ',JSON.parse(await response.data.text()));
            const returnJson = JSON.parse(await response.data.text())
            await axios.post(process.env.VUE_APP_BACKEND_API+'/docusign/sendEnvelope', {
              recipientEmail: this.email_to,
              recipientName: this.name_to,
              file: returnJson.file,
              filename: returnJson.filename,
              contratto_id: p_to_print.id,
              logo: p_to_print.logo
            },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              responseType: 'blob'
            })
            .then( () => {
              this.$vs.notify({
                color: 'success',
                time: 4000,
                title: 'Conferma',
                text: 'documento inviato con successo'
              })
              this.$emit('close')
            }).catch(e => {
              this.$vs.notify({
                color: 'danger',
                time: 4000,
                title: 'Errore',
                text: 'si è verificato un errore, riprovare più tardi'
              })
              this.$emit('close')
              console.log(e)
            })
            this.$vs.loading.close()
        }).catch(e => {
          this.$vs.notify({
            color: 'danger',
            time: 4000,
            title: 'Errore',
            text: 'si è verificato un errore, riprovare più tardi'
          })
          console.log(e)
          this.$emit('close')
          this.$vs.loading.close()
        })
      })
    },
    clearSignature() {
      this.$refs.signature.clear()
    },
    saveSignature() {
        let formData = {}
        const { isEmpty, data } = this.$refs.signature.save()
        if (!isEmpty) {
          formData['file'] = this.$refs.signature.save()
          formData['consulente'] = this.type == 'consulente' ? true : false
          formData['id'] = this.contratto.id
          axios.post( process.env.VUE_APP_BACKEND_API + '/contratto/upload_firma',
            formData,
            {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              onUploadProgress: ( progressEvent ) => {
                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
              }
            }
          ).then((r) => {
            this.$vs.notify({
              color: 'success',
              time: 4000,
              title: 'Firma caricata',
              text: ''
            })
            if (this.type != 'consulente') {
              axios.post(process.env.VUE_APP_BACKEND_API+'/contratto/avanza_stato', {id: this.contratto.id, id_stato: this.id_stato},{
                headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
              })
            }
            this.closeThis()
          }).catch((e) => {
            console.log('FAILURE!!', e);
          })
        } else { return }
    },
    closeThis() {
      this.$emit('close')
    }
  },
}
</script>

<style>
.vs-dialog {
  max-width: 800px !important;
}
</style>
